/**
 * @author hxliu 2020-04-13
 * 考试查看
 */
import React from 'react'
import { connect } from 'dva'
import moment from "moment";
import {getActionName} from './../ruleConfigure/config'
import { modelUtils } from "@/utils";
import { WizAuthority } from '@/containers/common';
import { component_tool, framework_tool, utils_tool } from "@/tool";
import {outputInfoColumns,recordTabelColumns  } from './config';

import {
    ChapterLook,
} from '@/containers/online';
let {
    WizSpin,
    WizCard,
    WizRow,
    WizCol,
    WizSurveyAudience,
    WizTabs,
    WizCollapse,
    WizButton,
    WizSearchBar,
    WizTable,
    WizDataTable,
    WizModalForm,
    WizAlert
} = component_tool
import { Spin } from 'antd'
const { TabPane } = WizTabs;
let { WizContainer } = framework_tool
let { Session, getPageData } = utils_tool


class RuleLook extends WizContainer {
    componentName = 'ruleLook'

    constructor(props) {
        super(props)
        const { history } = props;
        let record = {}
        // 如果是编辑页面，则缓存来自列表页的这条记录，避免刷新页面之后字段被销毁。
        if (history.location && history.location.pathname === '/rule/configureList/look') {
            if (history.location && history.location.record) {
              record = history.location.record;
                Session.set('RuleConfigureDetail', record)
            } else {
              record = Session.get('RuleConfigureDetail') || {};
            }
        }
        this.state = {
            ruleId:record['id'],
            record:record,
            initialValue:{}
        }
    }

    _componentDidMount = () => {
        if(this.state.ruleId){
  
          this.doAction({
            path: "ruleConfigure/editInfo",
            payload: {
              key: "ruleConfigure@editInfo",
              apiParams: { id:this.state.ruleId }
            }
          });
        }
    };
    propsAndStateOnChange = {
        ruleConfigureEditInfo: this._initvalue.bind(this),
        ruleConfigureRecordInfo:this.recordInit.bind(this)
    }
    recordInit(nextProps, nextState) {
      
      if(nextProps.ruleConfigureRecordInfo.code === 1){
      }else{
        wizNotice.error(nextProps.ruleConfigureRecordInfo.msg);
      }
      return true;
    }
    _initvalue(nextProps, nextState) {
        if(nextProps.ruleConfigureEditInfo.code === 1){
          const data = nextProps.ruleConfigureEditInfo.data
          nextState['initialValue']['actionType']  = data['actionType']
          nextState['initialValue']['bizType']  = data['bizType']
          nextState['initialValue']['bizId']  = data['bizId']
          nextState['initialValue']['ruleName']  = data['ruleName']
          nextState['initialValue']['bizName']  = data['bizName']
          
          let authCmd = {orgIds:Object.assign([], data['authCmd']['orgIds'].map(org=>Object.assign({},org))),
          positionIds:Object.assign([], data['authCmd']['positionIds'].map(position=>Object.assign({},position))),
          positionCategoryIds:Object.assign([], data['authCmd']['positionCategoryIds'].map(positionCategory=>Object.assign({},positionCategory))),
          personIds:Object.assign([], data['authCmd']['personIds'].map(person=>Object.assign({},person)))};
          nextState['initialValue']['authCmd']  = authCmd
          nextState['initialValue']['outputClass']  = data['outputClass']
          nextState['initialValue']['state']  = data['state']
          nextState['manageKey'] = new Date().getTime()
          if(data['outputInfoList'] && data['outputInfoList'] instanceof Array && data['outputInfoList'].length>0){
            nextState['initialValue']['outputClass'] =data['outputInfoList'].map(outputInfo=>outputInfo.outputClass).join(",")
            data['outputInfoList'].forEach(outputInfo=>{
              nextState['initialValue'][`limitType${outputInfo.outputClass}`] = outputInfo['limitType'] || null
              nextState['initialValue'][`outputFlag${outputInfo.outputClass}`] = outputInfo['outputFlag'] || null
              nextState['initialValue'][`outputValue${outputInfo.outputClass}`] = outputInfo['outputValue'] || null
              nextState['initialValue'][`limitCount${outputInfo.outputClass}`] = outputInfo['limitCount'] || null
              nextState['initialValue'][`limitCycleType${outputInfo.outputClass}`] = outputInfo['limitCycleType'] || null
              nextState['initialValue'][`outputFlagName${outputInfo.outputClass}`] = outputInfo['outputFlagName'] || null
              nextState['initialValue'][`outputName${outputInfo.outputClass}`] = outputInfo['outputName'] || null
            })
          }
        }else{
          wizNotice.error(nextProps.ruleConfigureEditInfo.msg);
        }
        return true;
      }



    _booleanConvert(key) {
        return key ? '是' : '否'
    }
    _timeConvret(time) {
        if (time != null && time != undefined) {
            return moment(time).format("YYYY-MM-DD HH:mm")
        } else {
            return ''
        }
    }



    _renderContentRow(ln, lv = '', rn, rv = '') {
        return (
            <WizRow className='administrationScope-row-item'>
                <WizCol className='col-item' span={3} offset={1}>{ln + '：'}</WizCol>
                <WizCol span={6}>{lv}</WizCol>
                <WizCol className='col-item' span={3} offset={2}>{rn + '：'}</WizCol>
                <WizCol span={9}>{rv}</WizCol>
            </WizRow>
        )
    }

    changeTab = (e) => {
      if (e === '3') {
        this.doAction({
            path: 'ruleConfigure/recordInfo',
            payload: {
                key: 'ruleConfigure@recordInfo',
                apiParams: { id:this.state.ruleId }
            },
        })
    }
    }
    _render(){
        const { record, data, chapterRecord, targetScopeRecord, message,initialValue } = this.state
        let { ruleConfigureLoading,ruleConfigureEditInfo,ruleConfigureRecordInfo } = this.props
        let outputInfoList  = ruleConfigureEditInfo && ruleConfigureEditInfo['data'] && ruleConfigureEditInfo['data']['outputInfoList'] ||[]
        let bizType = '';
        let state = '';
        if (record['state'] === 1) { state = '有效' }
        if (record['state'] === 0) { state = '无效' }
        if (initialValue['bizType'] === 0) { bizType = '课程' }
        if (initialValue['bizType'] === 1) { bizType = '考试' }
        if (initialValue['bizType'] === 8) { bizType = '线下课程' }
        if (initialValue['bizType'] === 24) { bizType = '帖子' }
        if (initialValue['bizType'] === 32) { bizType = '路径阶段' }
        if (initialValue['bizType'] === 16) { bizType = '路径评语' }
        return (
            <>
                <WizCard  title='查看规则信息' icon={0}>
                            {this._renderContentRow('行为',record['actionTypeName'] , '业务类型', bizType)}
                            {this._renderContentRow('业务实体', initialValue['bizName'], '名称', initialValue['ruleName'])}
                            {this._renderContentRow('产物类型', record['outputClassName'], '状态', state)}
                </WizCard>
                <WizCard>
                <WizTabs defaultActiveKey="1" onChange={this.changeTab}>
                    <TabPane tab="适应范围" key="1">
                            <Spin tip={'加载中'} spinning={ruleConfigureLoading}>
                                <WizAuthority  value={initialValue['authCmd']} mode='Show' labelWidth={4} />
                            </Spin>
                    </TabPane>
                    <TabPane tab="规则产物" key="2">
        <WizTable pagination={false} columns={outputInfoColumns(outputInfoList)} 
        dataSource={outputInfoList} />
                    </TabPane>
                    <TabPane tab="规则处理记录" key="3">
                      
                    <WizTable columns={recordTabelColumns(this)}  dataSource={ruleConfigureRecordInfo && ruleConfigureRecordInfo['data']||[]} />
                    </TabPane>
                </WizTabs>
            </WizCard>
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { ruleConfigure } = state;
    const ruleConfigureEditInfo = modelUtils.getModelEntity(ruleConfigure, "ruleConfigure@editInfo");
    const ruleConfigureRecordInfo = modelUtils.getModelEntity(ruleConfigure, "ruleConfigure@recordInfo");
    
    const load = modelUtils.getLoadingState(state, "ruleConfigure");
      return {
        ruleConfigureEditInfo,
        ruleConfigureRecordInfo,
      ...load
      };
}

export default connect(mapStateToProps)(RuleLook)
